import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { isWorkoutExportable, triggerWorkoutDownload } from "@/lib/workoutExport";

export const WorkoutDownloadMenu = ({ session, testId = "workout-download" }) => {
  const [loadingFormat, setLoadingFormat] = useState(null);

  if (!isWorkoutExportable(session)) {
    return null;
  }

  const handleDownload = async (format) => {
    if (loadingFormat) return;
    setLoadingFormat(format);
    try {
      await triggerWorkoutDownload(
        session.session_id,
        format,
        session.workout_name,
      );
    } catch (err) {
      const message = err?.response?.data?.detail?.message
        || err?.planError?.message
        || `Unable to generate ${format.toUpperCase()} workout. Please try again.`;
      toast.error(typeof message === "string" ? message : `Unable to generate ${format.toUpperCase()} workout. Please try again.`);
    } finally {
      setLoadingFormat(null);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="btn-secondary-app px-2 py-1 text-[10px] tracking-widest uppercase inline-flex items-center gap-1"
          data-testid={testId}
          disabled={Boolean(loadingFormat)}
          aria-label="Download workout"
        >
          {loadingFormat ? (
            <Loader2 className="w-3 h-3 animate-spin" aria-hidden="true" />
          ) : (
            <Download className="w-3 h-3" aria-hidden="true" />
          )}
          Download
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[9rem]">
        {["fit", "tcx", "zwo", "erg", "mrc"].map((format) => (
          <DropdownMenuItem
            key={format}
            onSelect={() => handleDownload(format)}
            disabled={loadingFormat === format}
            data-testid={`${testId}-${format}`}
          >
            Download {format.toUpperCase()}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
